import { useExperiment } from "@/contexts/analitica";
import { useVitrineStore } from "@/contexts/vitrine-provider";
import {
  ExperimentsFlags,
  ExperimentsVariants,
} from "@/services/amplitude/experiment";
import { formatOpeningHours } from "@/utils/formatters";

export const useIsStoreOpen = () => {
  const openingHoursExperiment = useExperiment(ExperimentsFlags.OpeningHours);
  const vitrine = useVitrineStore((state) => state.store.vitrine);
  const isOpenNow = vitrine.isOpenNow;
  const isAlwaysOpen = vitrine.openingHours?.openingMode === "always_open";
  const isAlwaysClosed = vitrine.openingHours?.openingMode === "always_closed";
  const isScheduled = vitrine.openingHours?.openingMode === "scheduled";

  return {
    isOpen: isAlwaysClosed ? false : !!(isAlwaysOpen || isOpenNow),
    flagOn: openingHoursExperiment?.key === ExperimentsVariants.On,
    flagOff: openingHoursExperiment?.key === ExperimentsVariants.Off,
    openingHours: vitrine.openingHours?.days
      ? formatOpeningHours(vitrine.openingHours.days)
      : "",
    isAlwaysOpen,
    isAlwaysClosed,
    isScheduled,
  };
};
